import * as React from "react";
import { useUser } from "../utils/AccountStore";
import StyledModal from "./StyledModel";
import { useDarkMode } from "../components/DarkModeSwitch";
import { FcSignature } from "react-icons/fc";
import Signature from "@uiw/react-signature/canvas";
import "../main.css";

export interface SignatureOptionValue {
    image: string;
    user: string;
    userName: string;
    timestamp: number;
}

const SignatureOption = ({ changed, value, disabled }) => {
    const { user } = useUser();
    const [signature, setSignature] = React.useState({} as SignatureOptionValue);

    React.useEffect(() => {
        setSignature(JSON.parse(value || "{}"));
    }, [value]);

    const [showModal, setShowModal] = React.useState(false);

    const signRef = React.useRef<any>();

    const doSign = () => {
        if (signRef.current) {
            let image = signRef.current.canvas.toDataURL("image/png");
            let signature = { image, user: user.id, userName: user.displayName, timestamp: +new Date() };
            setSignature(signature);
            changed(JSON.stringify(signature));
            setShowModal(false);
        }
    };

    const clearSign = () => {
        changed(null);
        setShowModal(false);
    };

    const [isDarkMode] = useDarkMode();

    return (
        <div className="m-2">
            <div
                className={`flex flex-row justify-between items-center p-2 gap-2 max-w-[200px] border-b border-gray-300 dark:border-gray-600 cursor-pointer transition-colors ${!disabled ? "hover:bg-gray-100 dark:hover:bg-gray-800" : ""}`}
                onClick={() => !disabled && setShowModal(true)}
            >
                {signature.image && <img src={signature.image} className="max-w-[200px]" style={{ filter: isDarkMode ? "invert(1)" : "" }} />}
                {!signature.image && <span className="text-gray-900 dark:text-gray-100">Click to Sign</span>}
                <FcSignature size="24px" />
            </div>
            <span className="text-gray-500 dark:text-gray-400 text-sm">{user.displayName}</span>
            {!!signature.timestamp && (
                <span className="text-gray-500 dark:text-gray-400 text-xs block">
                    {new Date(signature.timestamp).toLocaleString()}
                </span>
            )}
            <StyledModal isOpen={showModal} setIsOpen={() => setShowModal(false)}>
                <div className="flex flex-col gap-2">
                    <div className="border border-gray-300 dark:border-gray-600 rounded p-2">
                        <div style={{ filter: isDarkMode ? "invert(1)" : "" }}>
                            <Signature ref={signRef} />
                        </div>
                    </div>
                    <div className="flex flex-row justify-end gap-2">
                        {signature.image && (
                            <button 
                                className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600 transition-colors"
                                onClick={clearSign}
                            >
                                Remove Signature
                            </button>
                        )}
                        <button 
                            className="px-4 py-2 rounded bg-brand text-white hover:bg-brand-dark transition-colors"
                            onClick={doSign}
                        >
                            Confirm and Sign
                        </button>
                    </div>
                </div>
            </StyledModal>
        </div>
    );
};

export default SignatureOption;
